<template>
  <v-app-bar app fixed dark clipped-left color="primary">
    <v-toolbar-title class="headline text-uppercase">
      <span class="font-weight-bold">Club Thrive</span>
      <span class="font-weight-light"> | Admin</span>
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items>
      <v-btn v-if="$store.state.currentUser" text @click="logout()">
        Sign Out <v-icon right>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { auth } from '../firebaseConfig.js';

export default {
  name: 'App',
  methods: {
    logout() {
      auth
        .signOut()
        .then(() => {
          this.$store.dispatch('clearData');
          this.$router.push('/login');
        })
        .catch(err => {
          alert(err);
        });
    }
  }
};
</script>
